/* eslint-disable arrow-body-style */
import React from 'react';
import { SelectInput } from '@abyss/web/ui/SelectInput';
import {
  riskScoresFilterPanelsApi,
  useRiskScoreFilterPanelStore,
} from '../../mothership/riskScoresFilterPanel.state';
import { riskScoresId } from '../../types';

export const RiskActivitySelect = () => {
  const options = useRiskScoreFilterPanelStore(
    (state) => state.activityRangeOptions
  );
  const value = useRiskScoreFilterPanelStore((state) => state.activityRange);

  const { setRiskActivityRangeValue: setRiskActivityValue } =
    riskScoresFilterPanelsApi;

  return (
    <div
      data-cy={`${riskScoresId}SelectRiskActivity`}
      data-value={value}
      data-options={JSON.stringify(options)}
    >
      <SelectInput
        label="Risk Activity"
        placeholder="Select a Risk Activity range"
        value={value}
        onChange={setRiskActivityValue}
        options={options}
      />
    </div>
  );
};
